// extracted by mini-css-extract-plugin
module.exports = {"skipToContentButton":"Layout_skipToContentButton__GYaMi Button_button__ToF_l Button_primary__x_x6_ Button_xsmall__LJvgS","page-body":"Layout_page-body__M2Be3"};